import IReportSceneOutput from "@/api/models/IReportSceneOutput";

export default function createReportSceneOutput(): IReportSceneOutput {
  return {
    id: "",
    photoId: "",
    photoURL: "",
    state: "",
    date: "",
    note: "",
    companyId: "0"
  };
}
